import { useCallback } from 'react';
import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { firebaseConfig } from '@/lib/firebase/config';

export function useAnalytics() {
  const sendLog = useCallback((eventName: string, payload: Record<string, any>) => {
    // 检查是否已配置 Firebase
    if (!firebaseConfig.apiKey) {
      console.log('[Firebase] No API key configured, skipping initialization');
      return;
    }

    try {
      // 初始化 Firebase
      const app = getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);

      // 初始化 Analytics（仅在浏览器环境）
      if (typeof window !== 'undefined') {
        const analytics = getAnalytics(app);

        // 记录访问事件
        logEvent(analytics, eventName, payload);

        console.log('[Firebase] Initialized successfully');
      }
    } catch (error) {
      console.error('[Firebase] Initialization error:', error);
    }
  }, []);

  return sendLog;
}
